/* Hand-written GraphQL operations for notifications.
 *
 * These deliberately override the amplify-generated ops in src/graphql/*. The generated selection
 * sets include `recipient_aliases` (amplify emits every field of the Notification type), but that
 * field is a server-side routing concern for the onMyNotification subscription filter — it carries
 * the targeted recipient aliases (PII) and is never consumed by the client. We can't drop it from
 * the schema (the subscription filter matches against it), so instead the client sends these explicit
 * selection sets that OMIT it. Keep these in sync with the fields the
 * frontend actually reads.
 */
import * as APITypes from 'src/API';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const listMyNotifications = /* GraphQL */ `
  query ListMyNotifications {
    listMyNotifications {
      notification_id
      source
      event
      payload
      is_persistent
      is_read
    }
  }
` as GeneratedQuery<APITypes.ListMyNotificationsQueryVariables, APITypes.ListMyNotificationsQuery>;

export const onMyNotification = /* GraphQL */ `
  subscription OnMyNotification {
    onMyNotification {
      notification_id
      source
      event
      payload
      is_persistent
      is_read
    }
  }
` as GeneratedSubscription<
  APITypes.OnMyNotificationSubscriptionVariables,
  APITypes.OnMyNotificationSubscription
>;

export const markNotificationsRead = /* GraphQL */ `
  mutation MarkNotificationsRead {
    markNotificationsRead {
      numberOfRecordsUpdated
    }
  }
` as GeneratedMutation<
  APITypes.MarkNotificationsReadMutationVariables,
  APITypes.MarkNotificationsReadMutation
>;
